/**
 * Theme de la caisse : palette BoomPOS (frontend/src/styles/boomposTheme.js,
 * design section 2), chiffres tabulaires, grosses cibles tactiles.
 */
import { createTheme } from '@mui/material/styles';

export const palette = Object.freeze({
    primary: '#2563EB',
    primaryDark: '#1D4ED8',
    primaryLight: '#3B82F6',
    background: '#F8FAFC',
    surface: '#FFFFFF',
    border: '#E2E8F0',
    text: '#1E293B',
    textSecondary: '#64748B',
    textMuted: '#78859B',
    success: '#10B981',
    successOnTint: '#065F46',
    successTint: '#D1FAE5',
    warning: '#F59E0B',
    warningOnTint: '#92400E',
    warningTint: '#FEF3C7',
    error: '#EF4444',
    errorOnTint: '#B91C1C',
    errorTint: '#FEE2E2',
    info: '#0EA5E9',
    infoOnTint: '#0284C7',
    infoTint: '#E0F2FE',
});

export const caisseTheme = createTheme({
    palette: {
        mode: 'light',
        primary: { main: palette.primary, dark: palette.primaryDark, light: palette.primaryLight },
        success: { main: palette.success },
        warning: { main: palette.warning },
        error: { main: palette.error },
        info: { main: palette.info },
        background: { default: palette.background, paper: palette.surface },
        text: { primary: palette.text, secondary: palette.textSecondary },
        divider: palette.border,
    },
    typography: {
        fontFamily: 'Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: 16,
        button: { fontSize: 22, fontWeight: 700, textTransform: 'none' },
    },
    shape: { borderRadius: 8 },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: { fontVariantNumeric: 'tabular-nums' },
                '*:focus-visible': { outline: `3px solid ${palette.primary}`, outlineOffset: 2 },
                '@media (prefers-reduced-motion: reduce)': {
                    '*': { animationDuration: '0s !important', transitionDuration: '0s !important' },
                },
            },
        },
        MuiButton: {
            defaultProps: { disableElevation: true },
            styleOverrides: { root: { minHeight: 64 } },
        },
    },
});
